import { ITeacherAssignmentsSummaryResponse } from '@/entities/TeacherAssignment';
import AssignmentsIcon from '@/shared/assets/icons/assignments.svg';
import StudentsIcon from '@/shared/assets/icons/users.svg';
import { Svg } from '@/shared/ui/Svg';

export const TeacherAssignmentSummary = ({
  totalStudents,
  assignments,
}: ITeacherAssignmentsSummaryResponse) => {
  const { total, completed, awaitingReview, resubmissions } = assignments;
  const cards = [
    {
      title: 'Total students',
      value: totalStudents,
      icon: StudentsIcon,
      bgColor: 'bg-[#F5F5F5]',
    },
    {
      title: 'Total assignments',
      value: total,
      icon: AssignmentsIcon,
      bgColor: 'bg-[#F5F5F5]',
    },
    {
      title: 'Completed assignments',
      value: completed,
      bgColor: 'bg-green-positive',
    },
    {
      title: 'Awaiting review',
      value: awaitingReview,
      bgColor: 'bg-[#FFF1C2]',
    },
    {
      title: 'Resubmissions',
      value: resubmissions,
      bgColor: 'bg-red-secondary',
    },
  ];
  return (
    <ul className="flex gap-4">
      {cards.map((card) => (
        <li key={card.title} className={`${card.bgColor} p-3 rounded-[8px] flex-1 min-w-[150px]`}>
          <div className="flex items-center gap-x-3">
            <p className="text-[14px] font-medium text-black-pure">{card.title}</p>{' '}
            {card.icon && <Svg Icon={card.icon} width={18} height={18} />}
          </div>

          <p className="text-[34px] font-bold text-black-pure">{card.value}</p>
        </li>
      ))}
    </ul>
  );
};
